interface FusionChartInstance{
  chart: Object;
}

export default FusionChartInstance;